export default function UpperVectorIcon() {
  return (
    <svg
      width="44"
      height="100"
      viewBox="0 0 24 341"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0V340.5M22.5 56L12 66.5L1.5 56M22.5 240.5L12 251L1.5 240.5"
        stroke="url(#paint0_linear_74_12923)"
        strokeWidth="6"
      />
      <defs>
        <linearGradient
          id="paint0_linear_74_12923"
          x1="11.9505"
          y1="16"
          x2="11.9575"
          y2="307"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#28F2FF" />
          <stop offset="1" stopColor="#A596FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
